import { motion } from "framer-motion";

const STORY_IMAGE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/341vypte_0B5A9158%20kopie2.webp";

const StoryIntro = () => {
  return (
    <section
      className="relative overflow-hidden bg-ink"
      data-testid="story-intro-section"
      aria-label="Fotografie die het moment vertelt"
    >
      {/* Sfeerbeeld */}
      <div className="absolute inset-0">
        <img
          src={STORY_IMAGE}
          alt="Bruidspaar in stilte tijdens de ceremonie"
          className="w-full h-full object-cover object-center opacity-90 scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-ink/35" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-transparent to-ink" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(17,17,17,0.72)_0%,rgba(17,17,17,0.35)_45%,transparent_75%)]" />
      </div>

      <div className="relative container-x py-28 md:py-40">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-3xl text-center"
        >
          <p className="eyebrow text-gold">Mijn kijk op fotografie</p>

          <h2 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white">
            Fotografie die het <span className="italic text-gold">moment vertelt.</span>
          </h2>

          <span className="block w-16 h-px bg-gold/60 mx-auto mt-10" />

          <p
            data-testid="story-intro-lead"
            className="mt-10 font-serif text-2xl md:text-3xl leading-snug text-white font-medium"
          >
            Mijn stijl is documentair en journalistiek geïnspireerd.
          </p>

          <p className="mt-8 text-base md:text-lg leading-relaxed text-white/75">
            Ik observeer wat er gebeurt en probeer de spontane momenten, emoties en kleine details
            vast te leggen die samen het verhaal vertellen. Of het nu gaat om een huwelijk,
            evenement, gezin, huisdier of portret: ik zoek naar beelden die natuurlijk aanvoelen en
            waarbij je achteraf niet alleen ziet wát er gebeurde, maar het moment ook opnieuw kunt
            beleven.
          </p>

          <p className="mt-10 font-serif text-xl md:text-2xl italic leading-snug text-gold">
            Geen geforceerde poses. Geen standaardplaatjes.
            <br className="hidden sm:block" /> Wel echte momenten, emoties en verhalen.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default StoryIntro;
